export const CHART_METRICS = {
  MENTIONS: "mentions",
  SENTIMENT: "sentiment",
  REACH: "reach",
  AMPLIFICATION: "amplification",
  AVE: "ave",
} as const;

export const CHART_SLICE_BY = {
  TIME: "time",
  MEDIA_TYPE: "media_type",
  SNAPSHOT: "snapshot",
  COMPETITORS: "competitors",
} as const;

export const CHART_TYPES = {
  BAR: "bar",
  COLUMN: "column",
  LINE: "line",
  PIE: "pie",
} as const;

export const isMentionsMetricChart = (metric: string) =>
  metric === CHART_METRICS.MENTIONS;

export const isSentimentMetricChart = (metric: string) =>
  metric === CHART_METRICS.SENTIMENT;

export const isCompetitorsChart = (sliceBy: string) =>
  sliceBy === CHART_SLICE_BY.COMPETITORS;

export const isReachMetricChart = (metric: string) =>
  metric === CHART_METRICS.REACH;

export const isAmplificationMetricChart = (metric: string) =>
  metric === CHART_METRICS.AMPLIFICATION;

export const isAveMetricChart = (metric: string) =>
  metric === CHART_METRICS.AVE;
